import React, { useState, useEffect } from "react";
import Calendar from "../../composant/DatePicker";
import MenuNav from "../../composant/NavBarAdmin";

const Index = () => {
  const [menuConsulta, setMenuConsulta] = useState([]);
  const UrlBase = "https://ngs.adv.br/";

  const getMenuConsulta = async () => {
    try {
      const response = await fetch(UrlBase + "menu_consulta.php");
      const data = await response.json();
      setMenuConsulta(data);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    getMenuConsulta();
  }, []);

  return (
    <>
   
<div className="relative -mt-32">
      {/* HERO – PADRÃO CRIMINAL */}
      <section className="bg-slate-900 text-white py-24">
        <div className="max-w-3xl mx-auto px-6 text-center">
          <span className="text-sm tracking-wide uppercase text-white/60">
            Agendamento online
          </span>

          <h1 className="mt-3 text-3xl md:text-4xl font-semibold leading-tight">
            Consulta Jurídica
          </h1>

          <p className="mt-5 text-white/75 text-base leading-relaxed">
            Selecione o tipo de atendimento e o horário disponível.
            Todas as consultas são confirmadas previamente.
          </p>
        </div>
      </section>

      {/* CONTEÚDO */}
      <section className="py-24 bg-slate-50">
        <div className="max-w-4xl mx-auto px-6">
          
          <div className="bg-white rounded-3xl shadow-xl p-10">
            
            <div className="mb-8 text-center">
              <h2 className="text-xl font-semibold text-slate-900">
                Escolha sua consulta
              </h2>
              <p className="mt-2 text-sm text-slate-500">
                Após selecionar a data, siga as instruções para confirmação.
              </p>
            </div>

            {/* CALENDAR */}
            <Calendar menuConsulta={menuConsulta} />

            {/* AVISO DISCRETO */}
            <div className="mt-10 border-t pt-6 text-xs text-slate-500 leading-relaxed">
              <p>
                • O agendamento não garante o atendimento sem confirmação prévia.
              </p>
              <p className="mt-1">
                • Em situações urgentes, entre em contato pelo WhatsApp.
              </p>
            </div>

          </div>
        </div>
      </section>
	  </div>
    </>
  );
};

export default Index;
